<template>
  <div class="woori-crowd-intro">
    <v-container>
      <!-- 헤더 섹션 -->
      <v-row class="mb-12">
        <v-col cols="12" class="text-center">
          <div class="intro-header">
            <span class="intro-badge">정부 지원 사업</span>
            <h1 class="text-h3 font-weight-bold mb-4">
              중소벤처기업부 2025년<br />
              <span class="primary--text">우리동네 크라우드 펀딩</span>
            </h1>
            <p class="text-body-1 intro-description">
              지역 주민이 소상공인에게 사업자금을 투자하고<br />
              정부가 보조하는 상생형 펀딩입니다
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- 주요 혜택 섹션 -->
      <v-row class="mb-12">
        <v-col cols="12" class="mb-6">
          <h2 class="text-h4 text-center font-weight-bold mb-8">
            우리동네 크라우드 펀딩만의<br />
            <span class="primary--text">특별한 혜택</span>
          </h2>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="benefit-card h-100" elevation="2">
            <div class="benefit-icon">
              <v-icon x-large color="primary">mdi-cash-refund</v-icon>
            </div>
            <v-card-title class="text-h6 justify-center">펀딩수수료 전액 환급</v-card-title>
            <v-card-text class="text-center">
              <p class="mb-2">지역/직장/선호지역 투자자</p>
              <p class="font-weight-bold primary--text">30% 이상 펀딩 참여 시</p>
              <p>최소 대출금 충족 시 환급</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="benefit-card h-100" elevation="2">
            <div class="benefit-icon">
              <v-icon x-large color="primary">mdi-handshake</v-icon>
            </div>
            <v-card-title class="text-h6 justify-center">대출 금액의 4.5% 정부 지원</v-card-title>
            <v-card-text class="text-center">
              <p class="mb-2">인테리어, 배달포인트, 홍보 비용 등</p>
              <p class="font-weight-bold primary--text">자료 증빙 시</p>
              <p>납입하신 이자보다 더 많은 혜택</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="benefit-card h-100" elevation="2">
            <div class="benefit-icon">
              <v-icon x-large color="primary">mdi-gift</v-icon>
            </div>
            <v-card-title class="text-h6 justify-center">투자 리워드 제공</v-card-title>
            <v-card-text class="text-center">
              <p class="mb-2">투자자에게 제공되는 리워드로</p>
              <p class="font-weight-bold primary--text">매장 방문 유도</p>
              <p>적은 비용으로 마케팅 효과</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- 대출 조건 섹션 -->
      <v-row class="mb-12">
        <v-col cols="12">
          <v-card class="condition-card" elevation="2">
            <v-card-title class="text-h4 text-center font-weight-bold mb-6">
              대출 조건
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-list>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-account-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">자격</v-list-item-title>
                        <v-list-item-subtitle
                          >신용점수 500점 이상 소상공인<br />(현재 연체 보유 및 회생,파산,회복 시
                          불가)</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-cash-multiple</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">금액</v-list-item-title>
                        <v-list-item-subtitle
                          >5백만원 ~ 2천만원<br />(월 매출의 40% 이내)</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6">
                  <v-list>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-percent</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">금리</v-list-item-title>
                        <v-list-item-subtitle
                          >연 11%<br />납부 이자금액의 2~3배 마케팅 인센티브 지급<br />결과적으로
                          마이너스 금리</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-cash-sync</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">상환 방법</v-list-item-title>
                        <v-list-item-subtitle
                          >카드/배달 매출액의 10% 이내 자동 일상환<br />(원리금 상환시까지 평균
                          5~6개월, 최대 270일)</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- 신청하기 버튼 -->
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn
            color="primary"
            x-large
            @click="moveToMain"
            class="px-12 py-6 text-h6"
            elevation="4"
          >
            펀딩 신청하기
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'WooriCrowdIntro',
  methods: {
    moveToMain() {
      this.$router.push({ name: 'woori-crowd' })
    },
  },
}
</script>

<style lang="scss" scoped>
.woori-crowd-intro {
  padding: 4rem 0;
  background: linear-gradient(to bottom, #f8f9fa, #ffffff);

  .intro-header {
    .intro-badge {
      background: #e3f2fd;
      color: #1976d2;
      padding: 0.5rem 1rem;
      border-radius: 20px;
      font-weight: bold;
      margin-bottom: 1rem;
      display: inline-block;
    }

    .intro-description {
      color: #666;
      line-height: 1.8;
    }
  }

  .benefit-card {
    padding: 2rem 1rem;
    border-radius: 16px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
    }

    .benefit-icon {
      text-align: center;
      margin-bottom: 1rem;
    }
  }

  .condition-card {
    border-radius: 16px;
    padding: 2rem;

    .v-list-item {
      padding: 1rem 0;

      &-icon {
        margin-right: 1rem;
      }

      &-title {
        color: #333;
        margin-bottom: 0.5rem;
      }

      &-subtitle {
        color: #666;
        line-height: 1.6;
      }
    }
  }
}
</style>
